import PricingRate from './PricingRate'

/** Clase para los precios de la tarificación */
export default class RaterPricing {
  /** (String): Forma de pago. Ejemplo: "Mensual". */
  billingCycle!: string

  /** (String): Precio en euros. Ejemplo: "40,04". */
  price!: string

  /** (Integer): Número de cotización. Ejemplo: "4798669". */
  quotationNumber!: number

  /** (Integer): Código de cliente. Ejemplo: 24465. */
  clientCode!: number

  /** (Integer): Código de producto. Ejemplo: 102013. */
  productCode!: number

  /** (String): Línea de negocio. Ejemplo: "AS00". */
  businessLine!: string

  /** (DateTime): Fecha de inicio de seguro. Ejemplo: "2024-05-30". */
  insuranceStartDate!: string

  /** (Array): Listado de precios. */
  rates!: PricingRate[]

  constructor(data: any) {
    this.billingCycle = data.billingCycle
    this.price = data.price
    this.quotationNumber = data.quotationNumber
    this.clientCode = data.clientCode
    this.productCode = data.productCode
    this.businessLine = data.businessLine
    this.insuranceStartDate = data.insuranceStartDate
    this.rates = data.rates?.map((rateData: any) => new PricingRate(rateData))
  }
}
